import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/contract'

const initialState = () => ({
    contracts: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        contracts: state => state.contracts.data,
        pagination: state => state.contracts.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listContracts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listContracts(data)
                const contracts = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_CONTRACTS, contracts)
                return contracts
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetContracts: ({commit}) => commit(mutationTypes.RESET_CONTRACTS)
    },
    mutations: {
        [mutationTypes.RESET_CONTRACTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CONTRACTS]: (state, data) => state.contracts = data
    }
}
